"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var cardFormContext_1 = require("./cardFormContext");
var editor_web_1 = require("@21st-night/editor-web");
var getJSONValue_1 = __importDefault(require("../../helpers/getJSONValue"));
var __1 = require("../..");
var SET_FIELD_VALUE = 'SET_FIELD_VALUE';
var SET_VIEW = 'SET_VIEW';
var SET_ERRORS = 'SET_ERRORS';
var RESET = 'RESET';
function reducer(state, action) {
    var _a;
    switch (action.type) {
        case SET_FIELD_VALUE:
            return __assign(__assign({}, state), (_a = {}, _a[action.name] = action.value, _a));
        case SET_VIEW:
            return __assign(__assign({}, state), { view: action.view });
        case SET_ERRORS:
            return __assign(__assign({}, state), { errors: action.errors });
        case RESET:
            return __assign({}, action.state);
        default:
            throw new Error();
    }
}
var CardFormProvider = function (_a) {
    var children = _a.children, cardProp = _a.card, _b = _a.view, view = _b === void 0 ? 'question' : _b;
    var card = cardProp || __1.createCardDocument();
    var getCardValues = react_1.useCallback(function (card) {
        var explanation = card.explanation
            ? getJSONValue_1.default(card.explanation)
            : editor_web_1.generateRichTextDocument();
        var summary = card.summary
            ? getJSONValue_1.default(card.summary)
            : editor_web_1.generateRichTextDocument();
        return __assign(__assign({}, card), { answer: getJSONValue_1.default(card.answer), explanation: explanation, question: getJSONValue_1.default(card.question), summary: summary });
    }, []);
    var _c = __read(react_1.useReducer(reducer, __assign(__assign({}, getCardValues(card)), { errors: {}, view: view })), 2), state = _c[0], dispatch = _c[1];
    var onFieldChange = react_1.useCallback(function (event) {
        var name = event.target.getAttribute('name');
        var value = event.target
            .value;
        if (name) {
            dispatch({ name: name, type: SET_FIELD_VALUE, value: value });
        }
    }, []);
    var setValue = react_1.useCallback(function (name, value) {
        if (name) {
            dispatch({ name: name, type: SET_FIELD_VALUE, value: value });
        }
    }, []);
    var setView = react_1.useCallback(function (view) {
        dispatch({ type: SET_VIEW, view: view });
    }, []);
    var setErrors = react_1.useCallback(function (errors) {
        dispatch({ type: SET_ERRORS, errors: errors });
    }, []);
    var reset = react_1.useCallback(function (card, view) {
        if (card === void 0) { card = __1.createCardDocument(); }
        if (view === void 0) { view = 'question'; }
        // Rich text editor will not reset if visible
        // so we switch the the 'preview' view when resetting
        dispatch({
            state: __assign(__assign({}, getCardValues(card)), { errors: {}, view: 'preview' }),
            type: RESET,
        });
        // Switch back to the actual requested view
        dispatch({
            type: 'SET_VIEW',
            view: view,
        });
    }, [getCardValues]);
    var cardWithId = card;
    return (react_1.default.createElement(cardFormContext_1.Provider, { value: __assign(__assign({}, state), { onFieldChange: onFieldChange,
            reset: reset,
            setErrors: setErrors,
            setValue: setValue,
            setView: setView, originalCard: cardProp, id: cardWithId.id || null }) }, children));
};
exports.default = CardFormProvider;
//# sourceMappingURL=CardFormProvider.js.map